import React from "react";

const IdCardGallery = () => {
  return (
    <div className="container my-4" >
      <h4 className="text-center mb-3">ID Card Demo Designs</h4>
      <button onClick={()=>{
        window.print();
      }}>print</button>
      <div className="row g-4 justify-content-center">

        {/* Design 1 */}
        <div className="col-auto">
          <div className="card shadow rounded-3 border"
            style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
          >
            <div className="bg-primary text-white text-center p-2">
              <img src="https://via.placeholder.com/50" alt="School Logo" className="rounded-circle border border-white mb-1" />
              <h6 className="fw-bold text-uppercase mb-0" style={{ fontSize: "13px" }}>Springfield School</h6>
              <small style={{ fontSize: "9px" }}>Delhi</small>
            </div>
            <div className="text-center p-2">
              <div className="border rounded mx-auto mb-2"
                style={{ width: "90px", height: "100px", overflow: "hidden" }}
              >
                <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Student" className="img-fluid h-100 w-100" style={{ objectFit: "cover" }} />
              </div>
              <div className="text-start ps-2" style={{ fontSize: "11px" }}>
                <p><b>Name:</b> Rahul Sharma</p>
                <p><b>Class:</b> 10 A</p>
                <p><b>Roll:</b> 23</p>
                <p><b>DOB:</b> 12-05-2008</p>
                <p><b>Blood:</b> B+</p>
              </div>
            </div>
            <div className="bg-primary text-white text-center p-1"
              style={{ fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}
            >
              <p className="mb-0">📞 +91-9876543210</p>
              <p className="mb-0">123, MG Road</p>
            </div>
            <span className="badge bg-dark position-absolute top-0 end-0 m-1">1</span>
          </div>
        </div>

        {/* Design 2 */}
        <div className="col-auto">
          <div className="card shadow rounded-3 border"
            style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
          >
            <div className="bg-danger text-white text-center p-2">
              <h6 className="fw-bold text-uppercase mb-0">Modern Public School</h6>
              <small>Kolkata</small>
            </div>
            <div className="p-2 d-flex">
              <div className="me-2 border" style={{ width: "80px", height: "100px", overflow: "hidden" }}>
                <img src="https://randomuser.me/api/portraits/women/45.jpg" alt="Student" className="img-fluid h-100 w-100" style={{ objectFit: "cover" }} />
              </div>
              <div style={{ fontSize: "11px" }}>
                <p><b>Name:</b> Priya Verma</p>
                <p><b>Class:</b> 9 B</p>
                <p><b>Roll:</b> 12</p>
                <p><b>DOB:</b> 20-08-2009</p>
                <p><b>Blood:</b> O+</p>
              </div>
            </div>
            <div className="bg-danger text-white text-center p-1"
              style={{ fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}
            >
              <p className="mb-0">✉️ info@mpschool.com</p>
            </div>
            <span className="badge bg-dark position-absolute top-0 end-0 m-1">2</span>
          </div>
        </div>

        {/* Design 3 */}
        <div className="col-auto">
          <div className="card shadow rounded-3 border"
            style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
          >
            <div className="bg-success text-white text-center py-1">
              <h6 className="fw-bold text-uppercase mb-0">Green Valley School</h6>
            </div>
            <div className="text-center p-2">
              <img src="https://randomuser.me/api/portraits/men/11.jpg" alt="Student"
                className="rounded-circle mb-2"
                style={{ width: "80px", height: "80px", objectFit: "cover" }}
              />
              <div style={{ fontSize: "11px" }} className="text-start ps-2">
                <p><b>Name:</b> Amit Kumar</p>
                <p><b>Class:</b> 8 C</p>
                <p><b>Roll:</b> 45</p>
                <p><b>DOB:</b> 15-01-2010</p>
                <p><b>Blood:</b> A+</p>
              </div>
            </div>
            <div className="bg-success text-white text-center p-1"
              style={{ fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}
            >
              <p className="mb-0">📞 +91-1234567890</p>
            </div>
            <span className="badge bg-dark position-absolute top-0 end-0 m-1">3</span>
          </div>
        </div>

        {/* Design 4 */}
        <div className="col-auto">
          <div className="card shadow rounded-3 border"
            style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
          >
            <div className="bg-warning text-dark text-center py-2">
              <h6 className="fw-bold text-uppercase mb-0">Sunrise Academy</h6>
              <small>Lucknow</small>
            </div>
            <div className="p-2 text-center">
              <div className="border rounded mb-2 mx-auto" style={{ width: "90px", height: "100px", overflow: "hidden" }}>
                <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Student" className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
              </div>
              <div className="text-start ps-2" style={{ fontSize: "11px" }}>
                <p><b>Name:</b> Neha Gupta</p>
                <p><b>Class:</b> 7 A</p>
                <p><b>Roll:</b> 34</p>
                <p><b>DOB:</b> 05-09-2011</p>
                <p><b>Blood:</b> AB+</p>
              </div>
            </div>
            <div className="bg-warning text-dark text-center p-1"
              style={{ fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}
            >
              <p className="mb-0">✉️ sunrise@school.com</p>
            </div>
            <span className="badge bg-dark position-absolute top-0 end-0 m-1">4</span>
          </div>
        </div>

        {/* Design 5 */}
        <div className="col-auto">
          <div className="card shadow rounded-3 border"
            style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
          >
            <div className="bg-dark text-white text-center py-2">
              <h6 className="fw-bold text-uppercase mb-0">Oxford High</h6>
              <small>Mumbai</small>
            </div>
            <div className="p-2 text-center">
              <img src="https://randomuser.me/api/portraits/men/41.jpg" alt="Student"
                className="rounded-circle mb-2"
                style={{ width: "85px", height: "85px", objectFit: "cover" }}
              />
              <div className="text-start ps-2" style={{ fontSize: "11px" }}>
                <p><b>Name:</b> Arjun Mehta</p>
                <p><b>Class:</b> 11 B</p>
                <p><b>Roll:</b> 5</p>
                <p><b>DOB:</b> 18-03-2007</p>
                <p><b>Blood:</b> O-</p>
              </div>
            </div>
            <div className="bg-dark text-white text-center p-1"
              style={{ fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}
            >
              <p className="mb-0">📞 +91-9876001234</p>
            </div>
            <span className="badge bg-dark position-absolute top-0 end-0 m-1">5</span>
          </div>
        </div>

        <div className="col-auto">
          <div className="card shadow rounded-3 border"
            style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
          >
            <div className="bg-info text-white text-center py-2">
              <h6 className="fw-bold text-uppercase mb-0">Blue Star School</h6>
              <small>Pune</small>
            </div>
            <div className="p-2 d-flex">
              <div className="me-2 border rounded" style={{ width: "75px", height: "95px", overflow: "hidden" }}>
                <img src="https://randomuser.me/api/portraits/women/22.jpg" alt="Student" className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
              </div>
              <div style={{ fontSize: "11px" }}>
                <p><b>Name:</b> Sneha Patil</p>
                <p><b>Class:</b> 6 C</p>
                <p><b>Roll:</b> 27</p>
                <p><b>DOB:</b> 11-07-2012</p>
                <p><b>Blood:</b> A-</p>
              </div>
            </div>
            <div className="bg-info text-white text-center p-1"
              style={{ fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}>
              <p className="mb-0">✉️ contact@bluestar.edu</p>
            </div>
            <span className="badge bg-dark position-absolute top-0 end-0 m-1">6</span>
          </div>
        </div>

        {/* Design 7 */}
        <div className="col-auto">
          <div className="card shadow rounded-3 border"
            style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
          >
            <div className="bg-secondary text-white text-center py-2">
              <h6 className="fw-bold text-uppercase mb-0">Silver Oak School</h6>
              <small>Hyderabad</small>
            </div>
            <div className="p-2 text-center">
              <img src="https://randomuser.me/api/portraits/men/52.jpg" alt="Student"
                className="rounded mb-2"
                style={{ width: "90px", height: "100px", objectFit: "cover" }}
              />
              <div className="text-start ps-2" style={{ fontSize: "11px" }}>
                <p><b>Name:</b> Rohan Singh</p>
                <p><b>Class:</b> 12 A</p>
                <p><b>Roll:</b> 9</p>
                <p><b>DOB:</b> 02-12-2006</p>
                <p><b>Blood:</b> B-</p>
              </div>
            </div>
            <div className="bg-secondary text-white text-center p-1"
              style={{ fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}>
              <p className="mb-0">📞 +91-9023456789</p>
            </div>
            <span className="badge bg-dark position-absolute top-0 end-0 m-1">7</span>
          </div>
        </div>

        {/* Design 8 */}
        <div className="col-auto">
          <div className="card shadow rounded-3 border"
            style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
          >
            <div className="bg-purple text-white text-center py-2" style={{ background: "purple" }}>
              <h6 className="fw-bold text-uppercase mb-0">Lotus International</h6>
              <small>Jaipur</small>
            </div>
            <div className="p-2 d-flex">
              <div className="me-2 border rounded" style={{ width: "75px", height: "95px", overflow: "hidden" }}>
                <img src="https://randomuser.me/api/portraits/women/17.jpg" alt="Student" className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
              </div>
              <div style={{ fontSize: "11px" }}>
                <p><b>Name:</b> Anjali Joshi</p>
                <p><b>Class:</b> 5 B</p>
                <p><b>Roll:</b> 18</p>
                <p><b>DOB:</b> 21-11-2013</p>
                <p><b>Blood:</b> AB-</p>
              </div>
            </div>
            <div className="text-white text-center p-1"
              style={{ fontSize: "9px", background: "purple", position: "absolute", bottom: "0", width: "100%" }}>
              <p className="mb-0">✉️ info@lotusintl.com</p>
            </div>
            <span className="badge bg-dark position-absolute top-0 end-0 m-1">8</span>
          </div>
        </div>

        {/* Design 6 - Royal Blue + Gold */}
<div className="col-auto">
  <div className="card shadow rounded-3 border"
    style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
  >
    <div className="text-center p-2" style={{ background: "linear-gradient(45deg, #003366, #0055a5)", color: "gold" }}>
      <h6 className="fw-bold text-uppercase mb-0">St. Xavier’s School</h6>
      <small>Mumbai</small>
    </div>
    <div className="p-2 text-center">
      <div className="border border-warning rounded-circle mb-2 mx-auto" style={{ width: "85px", height: "85px", overflow: "hidden" }}>
        <img src="https://randomuser.me/api/portraits/women/22.jpg" alt="Student" className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
      </div>
      <div className="text-start ps-2" style={{ fontSize: "11px" }}>
        <p><b>Name:</b> Ananya Roy</p>
        <p><b>Class:</b> 6 C</p>
        <p><b>Roll:</b> 14</p>
        <p><b>DOB:</b> 22-07-2012</p>
        <p><b>Blood:</b> A-</p>
      </div>
    </div>
    <div className="text-center p-1" style={{ background: "#003366", color: "gold", fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}>
      <p className="mb-0">📞 +91-8888001122</p>
    </div>
    <span className="badge bg-dark position-absolute top-0 end-0 m-1">9</span>
  </div>
</div>

{/* Design 7 - Maroon + Cream */}
<div className="col-auto">
  <div className="card shadow rounded-3 border"
    style={{ width: "220px", height: "340px", fontFamily: "Georgia, serif", position: "relative" }}
  >
    <div className="text-center p-2" style={{ backgroundColor: "#800000", color: "#fffdd0" }}>
      <h6 className="fw-bold text-uppercase mb-0">Heritage Academy</h6>
      <small>Kolkata</small>
    </div>
    <div className="p-2 text-center">
      <div className="border rounded mb-2 mx-auto" style={{ width: "90px", height: "100px", overflow: "hidden" }}>
        <img src="https://randomuser.me/api/portraits/men/54.jpg" alt="Student" className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
      </div>
      <div className="text-start ps-2" style={{ fontSize: "11px" }}>
        <p><b>Name:</b> Karan Singh</p>
        <p><b>Class:</b> 7 B</p>
        <p><b>Roll:</b> 21</p>
        <p><b>DOB:</b> 19-11-2011</p>
        <p><b>Blood:</b> B-</p>
      </div>
    </div>
    <div className="text-center p-1" style={{ backgroundColor: "#800000", color: "#fffdd0", fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}>
      <p className="mb-0">✉️ heritage@school.com</p>
    </div>
    <span className="badge bg-dark position-absolute top-0 end-0 m-1">10</span>
  </div>
</div>

{/* Design 8 - Dark Green + Golden */}
<div className="col-auto">
  <div className="card shadow rounded-3 border"
    style={{ width: "220px", height: "340px", fontFamily: "Times New Roman, serif", position: "relative" }}
  >
    <div className="text-center p-2" style={{ backgroundColor: "#004225", color: "gold" }}>
      <h6 className="fw-bold text-uppercase mb-0">Laurel International</h6>
      <small>Delhi</small>
    </div>
    <div className="p-2 text-center">
      <img src="https://randomuser.me/api/portraits/women/26.jpg" alt="Student"
        className="rounded-circle mb-2"
        style={{ width: "80px", height: "80px", objectFit: "cover", border: "2px solid gold" }}
      />
      <div className="text-start ps-2" style={{ fontSize: "11px" }}>
        <p><b>Name:</b> Simran Kaur</p>
        <p><b>Class:</b> 5 A</p>
        <p><b>Roll:</b> 18</p>
        <p><b>DOB:</b> 14-02-2013</p>
        <p><b>Blood:</b> AB-</p>
      </div>
    </div>
    <div className="text-center p-1" style={{ backgroundColor: "#004225", color: "gold", fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}>
      <p className="mb-0">📞 +91-9000011223</p>
    </div>
    <span className="badge bg-dark position-absolute top-0 end-0 m-1">11</span>
  </div>
</div>

{/* Design 9 - Navy Blue Gradient with Left Photo */}
<div className="col-auto">
  <div
    className="card shadow rounded-3 border"
    style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
  >
    {/* Header */}
    <div className="text-center p-2" style={{ background: "linear-gradient(45deg,#001f3f,#004080)", color: "white" }}>
      <h6 className="fw-bold text-uppercase mb-0">Bluebells Academy</h6>
      <small>Gurgaon</small>
    </div>

    {/* Body: Left Image + Right Info */}
    <div className="d-flex p-2">
      <div className="me-2 border" style={{ width: "80px", height: "100px", overflow: "hidden" }}>
        <img src="https://randomuser.me/api/portraits/men/29.jpg" alt="Student"
          className="img-fluid h-100 w-100" style={{ objectFit: "cover" }} />
      </div>
      <div style={{ fontSize: "11px" }}>
        <p><b>Name:</b> Rohan Mehta</p>
        <p><b>Class:</b> 9 A</p>
        <p><b>Roll:</b> 16</p>
        <p><b>DOB:</b> 10-06-2009</p>
        <p><b>Blood:</b> O+</p>
      </div>
    </div>

    {/* Footer */}
    <div className="text-center p-1"
      style={{ backgroundColor: "#001f3f", color: "white", fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}>
      <p className="mb-0">📞 011-22334455</p>
      <p className="mb-0">bluebells.edu.in</p>
    </div>
    <span className="badge bg-dark position-absolute top-0 end-0 m-1">9</span>
  </div>
</div>
{/* Design 9 - Navy Blue Gradient with Left Photo */}
<div className="col-auto">
  <div
    className="card shadow rounded-3 border"
    style={{ width: "220px", height: "340px", fontFamily: "Arial, sans-serif", position: "relative" }}
  >
    {/* Header */}
    <div className="text-center p-2" style={{ background: "linear-gradient(45deg,#001f3f,#004080)", color: "white" }}>
      <h6 className="fw-bold text-uppercase mb-0">Bluebells Academy</h6>
      <small>Gurgaon</small>
    </div>

    {/* Body: Left Image + Right Info */}
    <div className="d-flex p-2">
      <div className="me-2 border" style={{ width: "80px", height: "100px", overflow: "hidden" }}>
        <img src="https://randomuser.me/api/portraits/men/29.jpg" alt="Student"
          className="img-fluid h-100 w-100" style={{ objectFit: "cover" }} />
      </div>
      <div style={{ fontSize: "11px" }}>
        <p><b>Name:</b> Rohan Mehta</p>
        <p><b>Class:</b> 9 A</p>
        <p><b>Roll:</b> 16</p>
        <p><b>DOB:</b> 10-06-2009</p>
        <p><b>Blood:</b> O+</p>
      </div>
    </div>

    {/* Footer */}
    <div className="text-center p-1"
      style={{ backgroundColor: "#001f3f", color: "white", fontSize: "9px", position: "absolute", bottom: "0", width: "100%" }}>
      <p className="mb-0">📞 011-22334455</p>
      <p className="mb-0">bluebells.edu.in</p>
    </div>
    <span className="badge bg-dark position-absolute top-0 end-0 m-1">12</span>
  </div>
</div>

{/* Horizontal Design - Premium Look */}
<div className="col-auto">
  <div
    className="card shadow rounded-3 border"
    style={{
      width: "340px",
      height: "200px",
      fontFamily: "Arial, sans-serif",
      position: "relative"
    }}
  >
    {/* Top Bar */}
    <div
      className="text-center p-1"
      style={{
        background: "linear-gradient(90deg,#004080,#0073e6)",
        color: "white"
      }}
    >
      <h6 className="fw-bold text-uppercase mb-0">St. Xavier’s School</h6>
      <small>Delhi</small>
    </div>

    {/* Body */}
    <div className="d-flex p-2">
      {/* Left Photo */}
      <div
        className="border me-2"
        style={{ width: "90px", height: "110px", overflow: "hidden" }}
      >
        <img
          src="https://randomuser.me/api/portraits/men/52.jpg"
          alt="Student"
          className="img-fluid h-100 w-100"
          style={{ objectFit: "cover" }}
        />
      </div>

      {/* Right Info */}
      <div style={{ fontSize: "12px" }}>
        <p><b>Name:</b> Karan Singh</p>
        <p><b>Class:</b> 12 C</p>
        <p><b>Roll:</b> 08</p>
        <p><b>DOB:</b> 02-12-2006</p>
        <p><b>Blood:</b> A+</p>
      </div>
    </div>

    {/* Bottom Bar */}
    <div
      className="text-center p-1"
      style={{
        backgroundColor: "#004080",
        color: "white",
        fontSize: "10px",
        position: "absolute",
        bottom: "0",
        width: "100%"
      }}
    >
      <p className="mb-0">📞 011-44556677 | ✉️ contact@stxaviers.edu.in</p>
    </div>
    <span className="badge bg-dark position-absolute top-0 end-0 m-1">H1</span>
  </div>
</div>

<div
  className="card shadow border rounded-3"
  style={{
    width: "350px",
    height: "200px",
    fontFamily: "Arial, sans-serif",
    position: "relative"
  }}
>
  {/* Header */}
  <div
    className="text-center p-1"
    style={{ background: "linear-gradient(90deg,#800000,#b30000)", color: "white" }}
  >
    <h6 className="fw-bold text-uppercase mb-0">Oxford International School</h6>
    <small>Staff ID Card</small>
  </div>

  {/* Body */}
  <div className="d-flex p-2">
    {/* Photo */}
    <div
      className="border me-2"
      style={{ width: "90px", height: "110px", overflow: "hidden" }}
    >
      <img
        src="https://randomuser.me/api/portraits/women/50.jpg"
        alt="Staff"
        className="img-fluid h-100 w-100"
        style={{ objectFit: "cover" }}
      />
    </div>

    {/* Info */}
    <div style={{ fontSize: "12px" }}>
      <p><b>Name:</b> Mrs. Shalini Rao</p>
      <p><b>Designation:</b> Mathematics Teacher</p>
      <p><b>Emp ID:</b> OIS-234</p>
      <p><b>Dept:</b> Science</p>
      <p><b>Blood:</b> B+</p>
    </div>
  </div>

  {/* Footer */}
  <div
    className="text-center p-1"
    style={{
      backgroundColor: "#800000",
      color: "white",
      fontSize: "10px",
      position: "absolute",
      bottom: "0",
      width: "100%"
    }}
  >
    <p className="mb-0">📞 +91-9876543210 | ✉️ hr@oxford.edu</p>
  </div>
</div>


<div
  className="shadow-lg rounded-4 overflow-hidden"
  style={{
    width: "360px",
    height: "200px",
    fontFamily: "'Poppins', sans-serif",
    background: "linear-gradient(135deg, #004e92, #000428)",
    color: "white",
    position: "relative"
  }}
>
  {/* Header Strip */}
  <div
    style={{
      background: "rgba(255,255,255,0.1)",
      padding: "4px 10px",
      fontSize: "12px",
      textAlign: "center",
      fontWeight: "600",
      letterSpacing: "1px"
    }}
  >
    Oxford International School – STAFF ID
  </div>

  {/* Content */}
  <div className="d-flex p-3">
    {/* Photo Circle */}
    <div
      style={{
        width: "90px",
        height: "90px",
        borderRadius: "50%",
        overflow: "hidden",
        border: "3px solid white"
      }}
    >
      <img
        src="https://randomuser.me/api/portraits/men/51.jpg"
        alt="Staff"
        className="w-100 h-100"
        style={{ objectFit: "cover" }}
      />
    </div>

    {/* Info */}
    <div className="ms-3">
      <h6 className="fw-bold mb-1" style={{ fontSize: "15px" }}>
        Mr. Rajeev Sinha
      </h6>
      <p className="mb-1" style={{ fontSize: "12px" }}>
        📌 <b>Designation:</b> Physics Teacher
      </p>
      <p className="mb-1" style={{ fontSize: "12px" }}>
        🆔 <b>Emp ID:</b> OIS-1021
      </p>
      <p className="mb-1" style={{ fontSize: "12px" }}>
        🩸 <b>Blood:</b> O+
      </p>
      <p className="mb-0" style={{ fontSize: "12px" }}>
        📞 +91-98765 43210
      </p>
    </div>
  </div>

  {/* Footer Strip */}
  <div
    style={{
      background: "rgba(255,255,255,0.1)",
      position: "absolute",
      bottom: 0,
      width: "100%",
      textAlign: "center",
      fontSize: "11px",
      padding: "4px"
    }}
  >
    ✉️ staff@oxford.edu | 🌐 www.oxfordschool.in
  </div>
</div>


<div
  className="shadow-lg rounded-4 overflow-hidden"
  style={{
    width: "230px",
    height: "350px",
    fontFamily: "'Poppins', sans-serif",
    background: "linear-gradient(180deg, #6a11cb, #2575fc)",
    color: "white",
    position: "relative"
  }}
>
  {/* School Header */}
  <div
    style={{
      background: "rgba(255,255,255,0.15)",
      textAlign: "center",
      padding: "8px"
    }}
  >
    <h6 className="fw-bold mb-0" style={{ fontSize: "13px" }}>
      Green Valley School
    </h6>
    <small style={{ fontSize: "10px" }}>Staff ID Card</small>
  </div>

  {/* Photo */}
  <div
    className="mx-auto my-3"
    style={{
      width: "100px",
      height: "100px",
      borderRadius: "50%",
      overflow: "hidden",
      border: "3px solid white"
    }}
  >
    <img
      src="https://randomuser.me/api/portraits/women/52.jpg"
      alt="Staff"
      className="w-100 h-100"
      style={{ objectFit: "cover" }}
    />
  </div>

  {/* Info */}
  <div className="px-3" style={{ fontSize: "12px" }}>
    <p><b>Name:</b> Ms. Shalini Gupta</p>
    <p><b>Designation:</b> English Teacher</p>
    <p><b>Emp ID:</b> GVS-458</p>
    <p><b>Department:</b> Languages</p>
    <p><b>Blood:</b> A+</p>
  </div>

  {/* Footer */}
  <div
    style={{
      background: "rgba(255,255,255,0.15)",
      textAlign: "center",
      padding: "6px",
      fontSize: "11px",
      position: "absolute",
      bottom: 0,
      width: "100%"
    }}
  >
    📞 +91-91234 56789 | ✉️ hr@gvs.edu
  </div>
</div>


<div
  className="shadow-lg rounded-4 overflow-hidden"
  style={{
    width: "360px",
    height: "200px",
    fontFamily: "'Poppins', sans-serif",
    background: "linear-gradient(135deg, #1E3C72, #2A5298)",
    color: "white",
    position: "relative",
    border: "3px solid gold"
  }}
>
  {/* Header */}
  <div
    style={{
      background: "rgba(255,255,255,0.15)",
      padding: "5px 10px",
      fontSize: "13px",
      fontWeight: "600",
      textAlign: "center",
      letterSpacing: "1px"
    }}
  >
    Springfield International – STAFF ID
  </div>

  {/* Content */}
  <div className="d-flex p-3">
    {/* Photo */}
    <div
      style={{
        width: "90px",
        height: "90px",
        borderRadius: "50%",
        overflow: "hidden",
        border: "3px solid white"
      }}
    >
      <img
        src="https://randomuser.me/api/portraits/men/51.jpg"
        alt="Staff"
        className="w-100 h-100"
        style={{ objectFit: "cover" }}
      />
    </div>

    {/* Info */}
    <div className="ms-3">
      <h6 className="fw-bold mb-1" style={{ fontSize: "15px" }}>
        Mr. Rajeev Sinha
      </h6>
      <p className="mb-1" style={{ fontSize: "12px" }}>
        📌 <b>Designation:</b> Physics Teacher
      </p>
      <p className="mb-1" style={{ fontSize: "12px" }}>
        🆔 <b>Emp ID:</b> SPR-120
      </p>
      <p className="mb-1" style={{ fontSize: "12px" }}>
        🩸 <b>Blood:</b> O+
      </p>
      <p className="mb-0" style={{ fontSize: "12px" }}>
        📞 +91-98765 43210
      </p>
    </div>
  </div>

  {/* Footer */}
  <div
    style={{
      background: "rgba(255,255,255,0.15)",
      textAlign: "center",
      fontSize: "11px",
      padding: "5px",
      position: "absolute",
      bottom: 0,
      width: "100%"
    }}
  >
    ✉️ staff@springfield.edu | 🌐 www.springfield.edu
  </div>
</div>




      </div>
    </div>
  );
};

export default IdCardGallery;
